






import Vue, { PropType } from 'vue';
import { FirestoreDate } from '@/modules/firestore';
// import { formatDateJP2 } from '@/modules/calender';
import { calender } from 'mostra';

export default Vue.extend({
  name: 'GChatDateLabel',
  props: {
    date: [Date, Object] as PropType<FirestoreDate>,
  },
  data() {
    return {
      formatDateJP2: calender.formatDateJP2,
    };
  },
});
